/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';

export default (props: { styles?: string }): Element<string> => (
  <div
    data-testid="LoadingOverlay"
    css={css('min-width: 335px; min-height: 150px;', props.styles || '')}
  >
    <i className="fa fa-spinner fa-spin" />
  </div>
);
